import { render, staticRenderFns } from "./atrativos-popup.vue?vue&type=template&id=6823b417&scoped=true"
import script from "./atrativos-popup.vue?vue&type=script&lang=js"
export * from "./atrativos-popup.vue?vue&type=script&lang=js"
import style0 from "./atrativos-popup.vue?vue&type=style&index=0&id=6823b417&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823b417",
  null
  
)

export default component.exports